<template>
	<div class="this-page">
		<template>
			<el-page-header @back="goBack" content="客户详细资料" style="margin:20px 0;">
			</el-page-header>
		</template>
		<template>
			<el-tabs type="border-card">
				<el-tab-pane label="基础资料">
					<div class="base-box">
						<div class="base-line">
							<div class="base-item">
								<div class="base-item-name">会员编号</div>
								<div class="base-item-value">{{base.base.id}}</div>
							</div>
							<div class="base-item">
								<div class="base-item-name">客户昵称</div>
								<div class="base-item-value">{{base.base.name}}</div>
							</div>
							<div class="base-item">
								<div class="base-item-name">手机号</div>
								<div class="base-item-value">{{base.base.mobile || '-'}}</div>
							</div>
							<div class="base-item">
								<div class="base-item-name">微信识别码</div>
								<div class="base-item-value">{{base.base.open_id || '-'}}</div>
							</div>
							<div class="base-item">
								<div class="base-item-name">邀请码</div>
								<div class="base-item-value">{{base.base.invite_code || '-'}}</div>
							</div>

						</div>
						<div class="base-line">

							<div class="base-item">
								<div class="base-item-name">帐户余额</div>
								<div class="base-item-value">{{base.base.balance / 100}}</div>
							</div>
							<div class="base-item">
								<div class="base-item-name">消费总额</div>
								<div class="base-item-value">{{base.statistics.consume.price}}</div>
							</div>
							<div class="base-item">
								<div class="base-item-name">消费次数</div>
								<div class="base-item-value">{{base.statistics.consume.times}}</div>
							</div>

							<div class="base-item">
								<div class="base-item-name">可用优惠券数量</div>
								<div class="base-item-value">{{base.statistics.coupon}}</div>
							</div>



						</div>
						<div class="base-line">


							<div class="base-item">
								<div class="base-item-name">待入库包裹</div>
								<div class="base-item-value">{{base.statistics.inCome}}</div>
							</div>

							<div class="base-item">
								<div class="base-item-name">可申请打包包裹</div>
								<div class="base-item-value">{{base.statistics.applyPack}}</div>
							</div>
							<div class="base-item">
								<div class="base-item-name">待支付订单</div>
								<div class="base-item-value">{{base.statistics.pay}}</div>
							</div>
							<div class="base-item">
								<div class="base-item-name">运输中订单</div>
								<div class="base-item-value">{{base.statistics.expressing}}</div>
							</div>
							<div class="base-item">
								<div class="base-item-name">签收订单</div>
								<div class="base-item-value">{{base.statistics.signed}}</div>
							</div>

						</div>
            <div class="base-line">
              <div class="base-item" v-if="base.base.identity_front">
                <div class="base-item-name">身份证正面</div>
                <div class="base-item-value"><el-image :src="getUrl(base.base.identity_front)" style="width: 200px" :preview-src-list="getUrls(base.base.identity_front)"/></div>
              </div>
              <div class="base-item" v-if="base.base.identity_back">
                <div class="base-item-name">身份证反面</div>
                <div class="base-item-value"><el-image :src="getUrl(base.base.identity_back)" style="width: 200px" :preview-src-list="getUrls(base.base.identity_back)"/></div>
              </div>
            </div>
					</div>
				</el-tab-pane>
				<el-tab-pane label="地址信息">

					<el-table
					      :data="base.address"
					      style="width: 100%">
					      <el-table-column
					        prop="mobile"
					        label="电话"
					       >
					      </el-table-column>
					      <el-table-column
					        prop="name"
					        label="姓名"
					        >
					      </el-table-column>
					      <el-table-column
					        prop="address"
					        label="地址">
					      </el-table-column>
					    </el-table>

				</el-tab-pane>
				<el-tab-pane label="订单信息">
					<el-table
					      :data="base.order"
					      style="width: 100%">
					      <el-table-column
					        prop="no"
					        label="运单号"
					        >
					      </el-table-column>
						  <el-table-column
						    prop="posterCountry"
						    label="出发地"
						   >
						  </el-table-column>
						  <el-table-column
						    prop="posterName"
						    label="寄件人"
						   >
						  </el-table-column>
						  <el-table-column
						    prop="receiverName"
						    label="收件人"
						   >
						  </el-table-column>
					      <el-table-column
					        prop="statusTitle"
					        label="状态"
					        >
					      </el-table-column>
					      <el-table-column
					        prop="price"
					        label="运单价格">
					      </el-table-column>
						  <el-table-column
						    prop="created"
						    label="下单时间">
						  </el-table-column>
					    </el-table>
				</el-tab-pane>
				<el-tab-pane label="包裹信息">
					<el-table
					      :data="base.package"
					      style="width: 100%">
					      <el-table-column
					        prop="express_no"
					        label="快递单号"
					        >
					      </el-table-column>
						  <el-table-column
						    prop="stock_id"
						    label="仓库">
							 <template slot-scope="scope">
								 {{scope.row.stock_id == 1 ?'体积仓':''}}{{scope.row.stock_id == 2 ?'重量仓':''}}{{scope.row.stock_id == 3 ?'家家团仓':''}}
								 </template>
						  </el-table-column>
						  <el-table-column
						    prop="stock_id"
						    label="是否入库">
						  							 <template slot-scope="scope">
						  								 {{scope.row.check_stock == 1 ?'已入库':'未入库'}}
						  								 </template>
						  </el-table-column>
						  <el-table-column
						    prop="stock_id"
						    label="是否转订单">
						  							 <template slot-scope="scope">
						  								 {{scope.row.to_order == 1 ?'已转订单':'未转订单'}}
						  								 </template>
						  </el-table-column>
						  <el-table-column
						    prop="package_mark"
						    label="包裹内容"
						   >
						  </el-table-column>

					      <el-table-column
					        prop="item_number"
					        label="包裹内数量"
					        >
					      </el-table-column>
					      <el-table-column
					        prop="total_price"
					        label="报关总价">
					      </el-table-column>
						  <el-table-column
						    prop="created_at"
						    label="添加时间">
						  </el-table-column>
					    </el-table>
				</el-tab-pane>
				<el-tab-pane label="收支记录">
					<el-table
					      :data="base.walletLog"
					      style="width: 100%">
					      <el-table-column
					        prop="note"
					        label="项目"
					       >
					      </el-table-column>
					      <el-table-column
					        prop=""
					        label="类型"
					        >
							<template slot-scope="scope">
													  								 {{scope.row.type == 1 ?'支出':'收入'}}
													  								 </template>
					      </el-table-column>
					      <el-table-column
					        prop="price"
					        label="金额">
					      </el-table-column>
						  <el-table-column
						    prop="created_at"
						    label="时间">
						  </el-table-column>
					    </el-table>
				</el-tab-pane>
				<el-tab-pane label="优惠券">
					<el-table
					      :data="base.coupons"
					      style="width: 100%">
					      <el-table-column
					        prop="coupon_id"
					        label="券编码"
					        >
					      </el-table-column>
						  <el-table-column
						    prop="coupon_name"
						    label="名称"
						   >
						  </el-table-column>
						  <el-table-column
						    prop="coupon_price"
						    label="金额"
						   >
						  </el-table-column>
						  <el-table-column
						    prop="coupon_minimum"
						    label="最低消费"
						   >
						  </el-table-column>
						  <el-table-column
						    prop="created_at"
						    label="领取时间"
						   >
						  </el-table-column>
					      <el-table-column
					        prop="expired_at"
					        label="过期时间"
					        >
					      </el-table-column>
					      <el-table-column
					        prop="used_at"
					        label="使用时间">
					      </el-table-column>
						  <el-table-column
						    prop="created"
						    label="状态">
							<template slot-scope="scope">
								<el-tag type="info" size="small" v-if="scope.row.status == -1">已失效</el-tag>
								<el-tag type="warning" size="small" v-if="scope.row.status == 1">已使用</el-tag>
								<el-tag type="success" size="small" v-if="scope.row.status == 0">未使用</el-tag>

							</template>
						  </el-table-column>
					    </el-table>
				</el-tab-pane>
			</el-tabs>
		</template>

	</div>
</template>
<script>
	export default {
		components: {

		},
		data() {
			return {
				id: '',
				load: {
					base: false
				},
				base: {},
			}
		},
		mounted() {
			this.id = this.$route.query.id
			this.getBase()
		},
		methods: {
			goBack() {
				this.$router.back()
			},
			getBase() {
				this.$fetch.post('User/getUserDetail', {
					id: this.id
				}, true).then(res => {
					this.load.base = true
					this.base = res
				})
			},
      getUrl(url){
        let u = decodeURI(unescape(url))
        console.log(u)
        return u
      },
      getUrls(url){
        let u = decodeURI(unescape(url))
        const a = []
        a[0] = u
        return a
      }
		}
	}
</script>

<style>
	.this-page {
		padding: 10px;
		background-color: #FFFFFF;
	}

	.base-box {
		border-top: 1px solid #EEEEEE;
	}

	.base-line {
		display: flex;
		align-items: stretch;
		border-bottom: 1px solid #EEEEEE;

		border-left: 1px solid #EEEEEE;
	}

	.base-item {
		display: flex;
		align-items: stretch;
		flex: 1;
	}

	.base-item-name {
		background-color: #fcfcfc;
		flex: 0 0  auto;
		display: flex;
		align-items: center;
		padding:15px 20px;
		border-right: 1px solid #EEEEEE;
		font-size: 14px;
	}
	.base-item-value {
		font-size: 14px;
		flex: 1 1 auto;
		display: flex;
		align-items: center;
		padding:15px 20px;
		border-right: 1px solid #EEEEEE;
		word-break: break-all;

	}
</style>
